import { html, TemplateElement } from '@webtides/element-js';
import '../../../elements/responsive-table-controller/responsive-table-controller';

import style from './frame-geometry.css';

export default class FrameGeometry extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [style] });
    }

    properties() {
        return {
            geometries: [],
            keyHeader: 'rahmen_geometrien_rahmenhoehe',
            mapping: {
                rahmen_geometrien_oberrohr_horizontal: { label: 'A', unit: 'mm' },
            },
        };
    }

    getValuesForKey(key, geometries) {
        return geometries.map(frameGeometry => this.getValueWithUnit(key, frameGeometry[key]));
    }

    getValueWithUnit(key, geometry) {
        const unit = geometry?.unit ?? this.mapping[key]?.unit ?? '';

        const value = geometry?.label ?? '';
        return value ? `${value} ${unit}` : '-';
    }

    renderData() {
        const sortedGeometries = this.geometries.sort((a, b) => a[this.keyHeader].value - b[this.keyHeader].value);
        const columns = this.getValuesForKey(this.keyHeader, sortedGeometries);

        const keys = Object.keys(this.mapping);
        const rows = keys.map(key => {
            const values = this.getValuesForKey(key, sortedGeometries);

            return [this.mapping[key].label, ...values];
        });

        return html`
            <table>
                ${this.renderHeader(columns)} ${this.renderRows(rows)}
            </table>
        `;
    }

    renderHeader(columns) {
        return html`
            <thead>
                <tr>
                    <th class="spacing"></th>
                    ${columns.map(column => html` <th>${column}</th> `)}
                </tr>
            </thead>
        `;
    }

    renderRows(rows) {
        return html`
            <tbody>
                ${rows.map((row, index) => this.renderRow(row, index))}
            </tbody>
        `;
    }

    renderRow(row, index) {
        return html`
            <tr>
                ${row.map((cell, cellIndex) => this.renderCell(cell, cellIndex, index))}
            </tr>
        `;
    }

    renderCell(cell, cellIndex, rowIndex) {
        const classes = cellIndex === 0 ? 'solid uppercase' : '';

        return html`
            <td class="${classes}">
                ${cellIndex === 0
                    ? html`
                          <div class="cell-letter inline-block mr-3">
                              <span>${this.getLetterInAlphabet(rowIndex)}</span>
                          </div>
                      `
                    : ''}
                ${cell}
            </td>
        `;
    }

    getLetterInAlphabet(value) {
        return (value + 10).toString(36).toUpperCase();
    }

    template() {
        return html`
            <responsive-table-controller
                class="block table-container"
                collapsed-header-class="collapsed"
                collapsed-table-class="collapsed"
                tab-selector="th:not(.spacing)"
                cell-selector="td:not(.solid)"
            >
                ${this.renderData()}
            </responsive-table-controller>
        `;
    }
}
